import { Stack } from '@mui/material'
import { useRecurrenceEnd } from '../../../providers/StateProvider'
import { RecurrenceEndDropdown } from './components/RecurrenceEndDropdown/RecurrenceEndDropdown'
import { RecurrenceEndOccurrencePicker } from './components/RecurrenceEndOccurrencePicker/RecurrenceEndOccurrencePicker'
import { RecurrenceEndCalendar } from './components/RecurrenceEndCalendar'

export function RecurrenceEnd() {
  const recurrenceEnd = useRecurrenceEnd()

  return (
    <Stack
      sx={{
        direction: 'row',
        gap: 1,
      }}
    >
      <RecurrenceEndDropdown type={recurrenceEnd.endType} />
      {recurrenceEnd.endType === 'ON_DATE' && (
        <RecurrenceEndCalendar date={recurrenceEnd.endDate} />
      )}
      {recurrenceEnd.endType === 'AFTER_NUMBER' && (
        <RecurrenceEndOccurrencePicker
          requiredRecurrences={recurrenceEnd.numOfRecurrencesRequired}
        />
      )}
    </Stack>
  )
}
